import { call, put } from "@redux-saga/core/effects"
import getErrorMessage from "../../functions/getErrorMessage"
import actionTypes from "../../../app/action/actionTypes"

function* putError(actionType, e) {
    yield console.log(`${actionType}: `, e)

    const msg = yield call(getErrorMessage, e)

   yield put ({
       type: actionTypes[actionType],
       payload: {
           error: msg
       }
   })
}

export default putError